import TH from './th.json'
import EN from './en.json'

export const defaultLocale = localStorage.getItem('lang') ? localStorage.getItem('lang') : 'TH'

export const languages = {
  TH: TH,
  EN: EN
}